module.exports = __webpack_public_path__ + "static/media/about.ecfcda61.jpg";